// extracted by mini-css-extract-plugin
export default {"SummaryText":"ZoneDetail_SummaryText__eiszp","TableRow":"ZoneDetail_TableRow__9ZV4e","TableHeader":"ZoneDetail_TableHeader__LaFAc"};